import "./relationshipHeader.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import RelationshipHeaderGroupView from "../../components/relationshipView/RelationshipHeaderGroupView";
import { withXScrollPositionContext } from "../../components/scrollable/ScrollPositionContext";
import { RELATIONSHIP_EVENT_COLUMN_WIDTH, RELATIONSHIP_GROUP_LABEL_WIDTH } from "../../constants";
import { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { immutableRecords, PropTypeShapes } from "../../types";

// import debugUtils from "../../utils/debugUtils";

class RelationshipColumnHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      popoverOpen: false,
      leftMostGroup: 0
    };

    this.onItemDoubleClick = this.onItemDoubleClick.bind(this);
  }

  componentWillMount() {
    this.setState({
      leftMostGroup: 0,
      popoverOpen: false
    });
  }

  componentWillReceiveProps(nextProps) {
    // debugUtils.logPropChanges("RelationshipColumnHeaderView", this.props, nextProps, true);
    this.updateScrollArrow(nextProps.colGroups);
  }

  notifyScroll(_scrollLeft) {
    this.updateScrollArrow(this.props.colGroups);
  }

  updateScrollArrow(colGroups) {
    const SCALED_COLUMN_WIDTH = scalePixelsToFontSize(RELATIONSHIP_EVENT_COLUMN_WIDTH, this.props.fontSize);
    const SCALED_GROUP_LABEL_WIDTH = scalePixelsToFontSize(RELATIONSHIP_GROUP_LABEL_WIDTH, this.props.fontSize);

    const scrollLeft = this.props.xScrollPosition.absoluteScroll;
    // Work out which header should have the arrow... we want to pick the left-most one that has not started scrolling
    // off the screen...
    let sum = SCALED_COLUMN_WIDTH - SCALED_GROUP_LABEL_WIDTH - scrollLeft;
    const lefts = colGroups.map(g => {
      const result = sum;
      sum += g.width;
      return result;
    });
    const chosenColumn = lefts.findLastIndex(l => l <= SCALED_COLUMN_WIDTH);
    if (this.state.leftMostGroup !== chosenColumn) {
      this.setState({ leftMostGroup: chosenColumn });
    }
  }

  renderColGroups(
    colGroups,
    leftMostGroup,
    onItemClick,
    viewId,
    isActiveView,
    selectedItemIds,
    onMoveItem,
    allowColumnDrag,
    onLabelChange,
    onItemDoubleClick,
    fontSize,
    showEntityColor,
    onCreateItemClick
  ) {
    return colGroups.map((g, i) => {
      const showLabel = i !== 0;
      return (
        <RelationshipHeaderGroupView
          key={g.id}
          id={g.id}
          width={g.width}
          showLabel={showLabel}
          showEntityColor={showEntityColor}
          label={g.label}
          labelDisplay={g.labelDisplay}
          columns={g.cols}
          onItemClick={onItemClick}
          onItemDoubleClick={onItemDoubleClick}
          onLabelChange={onLabelChange}
          viewId={`${viewId}-header-group-${g.id}`}
          isActiveView={isActiveView}
          selectedItemIds={selectedItemIds}
          onMoveItem={onMoveItem}
          allowColumnDrag={allowColumnDrag}
          fontSize={fontSize}
          onCreateItemClick={onCreateItemClick}
        />
      );
    });
  }

  onItemDoubleClick() {
    if (this.props.onShowInspector) {
      this.props.onShowInspector();
    }
  }

  render() {
    const rowStyle = {
      width: this.props.width + "px",
      flex: `0 0 ${this.props.width}px`
    };

    return (
      <div className="relationshipTableColumnHeader">
        <div className="relationshipTableHeaderRow" style={rowStyle}>
          {this.renderColGroups(
            this.props.colGroups,
            this.state.leftMostGroup,
            this.props.onItemClick,
            this.props.viewIds.first(),
            this.props.isActiveView,
            this.props.selectedItemIds,
            this.props.onMoveItem,
            this.props.allowColumnDrag,
            this.props.onLabelChange,
            this.onItemDoubleClick,
            this.props.fontSize,
            this.props.showEntityColor,
            this.props.onCreateItemClick
          )}
        </div>
      </div>
    );
  }
}

RelationshipColumnHeaderView.propTypes = {
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  fontSize: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  allowedGroups: PropTypeShapes.listOptionGroupList,
  onItemClick: PropTypes.func.isRequired,
  showEntityColor: PropTypes.bool.isRequired,
  onShowInspector: PropTypes.func,
  onLabelChange: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onColumnToggle: PropTypes.func.isRequired,
  isActiveView: PropTypes.bool.isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  onMoveItem: PropTypes.func.isRequired,
  allowColumnDrag: PropTypes.bool,
  onCreateItemClick: PropTypes.func.isRequired,

  // From withScrollPositionContext
  xScrollPosition: PropTypes.instanceOf(immutableRecords.ScrollPositionRecord).isRequired
};

export default withXScrollPositionContext(RelationshipColumnHeaderView);
